<template>
    <div>
        <div class="file-upload" :class="{ 'error-border': errorType }">
            <div class=" drop-zone" @dragenter="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop="handleDrop">
                <div>
                    <img src="@/assets/images/onboarding/uploadFile.svg" alt="file-upload">
                </div>
                <div>

                    <p v-if="!isDragging">Drag & drop your file here or <span class="browse"
                            @click="openFileInput">browse</span></p>
                    <p v-else>Drop your files here</p>

                </div>
            </div>
            <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" />

            <div class="upload-footer">
                <p>Accepts .jpg and pdf</p>
                <p>Maximum file size: 2mb</p>
            </div>

        </div>
        <div v-if="fileName || link" class="file-preview" :class="{ 'error-border': showWarning }">
            <div class="title">
                <img :src="uploadIcon" alt="image-icon">
                <div class="sub-title">
                    <p class="file-name"><span v-if="fileName">File Name:</span> {{ fileName ? fileName : link }}</p>
                    <p v-if="fileName">{{ fileSize }} kb</p>
                </div>
            </div>

            <div v-if="fileName" class="close-icon" @click="clearFileSelection(type)">
                <img src="@/assets/images/onboarding/closeIcon.svg" alt="close-icon">
            </div>

        </div>
        <div v-if="showWarning" class="warning-message">
            <p>{{ warningMessage }}</p>
        </div>
    </div>
</template>
  
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
    props: ['type', 'link', 'errorType'],
    data() {
        return {
            isDragging: false,
            fileName: '',
            fileSize: '',
            showWarning: false,
            warningMessage: '',
            uploadIcon: require('@/assets/images/onboarding/fileIcon.svg'),
            imageUrl: null,
            base64Image: null,
        };
    },
    computed: {
        ...mapState("onboarding", {
            formBankDetails: state => state.formBankDetails,
            bankDetails: state => state.bankDetails
        }),
    },
    methods: {
        getImageSrc(extension) {
            const imgExt = ['jpg', 'png']
            const fileExt = ['doc', 'pdf']
            if (imgExt.includes(extension)) {
                this.uploadIcon = require('@/assets/images/onboarding/imageUpload.svg')
            }
            if (fileExt.includes(extension)) {
                this.uploadIcon = require("@/assets/images/onboarding/fileIcon.svg")
            }

        },
        clearFileSelection(type) {
            if (this.type === 'government_id')
                this.$store.commit('onboarding/setGovernmentIdError', false)
            if (this.type === "banking_proof") {
                this.$store.commit('onboarding/setProofOfBankingError', false)
            }
            if (this.type === "other_government_docu") {
                this.$store.commit('onboarding/setOtherGovenmentDocuError', false)
            }
            this.$store.commit('onboarding/removeBase64String', this.type);
            this.loadImageLink()
            this.$refs.fileInput.value = '';
            this.showWarning = false;
            this.fileName = '';
            this.fileSize = '';
        },
        dragEnter() {
            this.isDragging = true;
        },
        dragLeave() {
            this.isDragging = false;
        },
        handleDrop(event) {
            event.preventDefault();
            this.isDragging = false;
            const files = event.dataTransfer.files;
            this.fileName = files[0].name
            const size = files[0].size
            this.fileSize = this.bytesToKB(size)
            this.processFile(files[0]);
            if (this.type === 'government_id')
                this.$store.commit('onboarding/setGovernmentIdError', false)
            if (this.type === "banking_proof") {
                this.$store.commit('onboarding/setProofOfBankingError', false)
            }
            if (this.type === "other_government_docu") {
                this.$store.commit('onboarding/setOtherGovenmentDocuError', false)
            }

        },
        handleFileChange(event) {
            const files = event.target.files;
            this.fileName = files[0].name;
            const size = files[0].size
            this.fileSize = this.bytesToKB(size)
            this.processFile(files[0]);
            if (this.type === 'government_id')
                this.$store.commit('onboarding/setGovernmentIdError', false)
            if (this.type === "banking_proof") {
                this.$store.commit('onboarding/setProofOfBankingError', false)
            }
            if (this.type === "other_government_docu") {
                this.$store.commit('onboarding/setOtherGovenmentDocuError', false)
            }


        },
        openFileInput() {
            this.$refs.fileInput.click();
        },
        bytesToKB(fileSizeInBytes) {
            return (fileSizeInBytes / 1024).toFixed(2);
        },
        async processFile(file) {
            const validExtensions = ['jpg', 'pdf'];
            const validSizeInBytes = 2 * 1024 * 1024; // 2MB in bytes

            this.fileName = file.name;
            this.fileSize = this.bytesToKB(file.size);

            const fileExtension = this.getFileExtension(file.name);
            if (!validExtensions.includes(fileExtension)) {
                // Invalid file extension
                this.showWarning = true;
                this.warningMessage = 'Invalid file format. Accepted formats: .jpg, .pdf';
                return;
            }
            this.getImageSrc(fileExtension)

            // Check if the file size is within the limit
            if (file.size > validSizeInBytes) {
                // File size exceeds the limit
                this.showWarning = true;
                this.warningMessage = 'File size exceeds the limit. Maximum size: 2MB';
                return;
            }

            const base64Data = await this.toBase64(file)
            const fileData = {
                "type": this.type,
                "file": base64Data
            }
            this.$store.commit('onboarding/setBase64File', fileData);

            this.showWarning = false;
        },

        getFileExtension(filename) {
            return filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = (e) => {
                    const result = e.target.result;
                    const fileType = file.type;
                    const base64Prefix = `data:${fileType};base64,`;
                    const base64 = result.replace(new RegExp(`^${base64Prefix}`, 'i'), '');
                    return resolve(base64);
                };

                reader.onerror = (error) => {
                    return reject(error);
                };
            });
        },
        loadImageLink() {
            if (this.link !== null) {
                if (this.link.endsWith(".pdf") || this.link.endsWith(".doc")) {
                    this.uploadIcon = require("@/assets/images/onboarding/fileIcon.svg")
                }
                if (this.link.endsWith(".jpg") || this.link.endsWith(".png")) {
                    this.uploadIcon = require('@/assets/images/onboarding/imageUpload.svg')
                }
            }


        },

        mounted() {
            this.loadImageLink()


        },

    }
};
</script>
<style lang="scss" scoped>
.warning-message {
    margin-bottom: 0px;
    color: red;
    font-family: MainFontRegular, sans-serif;
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    margin-top: 3px;
}

.close-icon {
    cursor: pointer;
}

.file-preview {
    border-radius: 8px;
    border: 1px solid #E9EBED;
    margin-top: 30px;
    min-height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9px;
    word-wrap: break-word;

    .title {
        display: flex;

        img {
            margin-right: 8px;
        }

        .sub-title {
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: center;
            max-width: 300px;

            p {
                margin-bottom: 0px;
            }

            .file-name {
                display: inline-block;
                word-break: break-word;
            }

            @media (max-width: 672px) {
                max-width: 100px;
            }
        }
    }
}

.upload-footer {
    margin-top: 7px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    p {
        margin-bottom: 0px;
        color: #87929D;
        font-family: MainFontRegular, sans-serif;
        font-size: 12px;
        font-style: normal;
        line-height: normal;
    }
}

.browse {
    color: #2B62ED;
    font-family: MainFontRegular, sans-serif;
    font-size: 13px;
    font-style: normal;
    line-height: normal;
}

.drop-zone button {
    margin-top: 10px;
    background-color: #53b6b2;
    color: #ffffff;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
}

.drop-zone button:hover {
    background-color: #3a8f8a;
}

.file-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    height: 68px;
    border: 2px dashed #D8DCDE;
}

.error-border {
    border: solid red 1px;
}

.drop-zone {
    padding: 20px;
    width: 100%;
    height: 100%;
    text-align: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 14px;
}

.drop-zone p {
    margin: 0;
    font-size: 14px;
    color: #666;

}

.drop-zone p:last-child {
    margin-top: 10px;
}

.drop-zone.dragging {
    border-color: #53b6b2;
}
</style>
